import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { changeCollabStatus } from 'redux/colabsSlice';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';
import PropTypes from 'prop-types';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';

const DisableModal = ({ user, setShow, switchNewUser, setSwitchNewUser }) => {
  const dispatch = useDispatch();

  const handleClose = () => setShow(false);
  const handleDisable = async () => {
    dispatch(changeCollabStatus(user.id, 'disabled'));
    setSwitchNewUser(!switchNewUser);
    handleClose();
  };

  return (
    <>
      <Modal
        keyboard={true}
        show={true}
        onHide={handleClose}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <FontAwesomeIcon
            icon="fa-pause"
            title="Deshabilitar"
            size="1x"
            style={{ marginRight: 8, color: '#02a8b5' }}
          />

          <Modal.Title>Deshabilitar usuario</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-4">
            El usuario{' '}
            <b>
              {user.firstName} {user.lastName}
            </b>{' '}
            ya no podrá ingresar con su cuenta.
            <br />
            <br />
            ¿Está seguro de confirmar esta acción?
          </div>
          <ModalButtonsContainer>
            <ButtonClose
              text="Cancelar"
              funcion={handleClose}
              variant="secondary"
            />

            <ButtonAccept text="Confirmar" funcion={handleDisable} />
          </ModalButtonsContainer>
        </Modal.Body>
      </Modal>
    </>
  );
};

DisableModal.propTypes = {
  user: PropTypes.object.isRequired,
  setShow: PropTypes.func.isRequired,
  switchNewUser: PropTypes.bool.isRequired,
  setSwitchNewUser: PropTypes.func.isRequired
};

export default DisableModal;
